import styled from 'styled-components';
import media from '../../../ui/media';
export const Logo = styled.div.withConfig({
  displayName: "Style__Logo",
  componentId: "sc-z6sg4i-0"
})(["height:", "px;margin-bottom:16px;img{height:100%;}"], ({
  height = '24'
}) => height);
export const Question = styled.div.withConfig({
  displayName: "Style__Question",
  componentId: "sc-z6sg4i-1"
})(["position:relative;display:flex;flex:0 0 auto;flex-flow:column;padding:31px 24px 30px;&:after{position:absolute;bottom:100%;left:24px;content:'';border-right:10px solid transparent;border-bottom:12px solid ", ";border-left:10px solid transparent;", "}", ""], ({
  theme: {
    color
  }
}) => color.white, media.xs`
      left: 16px;
    `, media.xs`
    padding: 30px 16px 24px;
  `);
export const QuestionTitle = styled.div.withConfig({
  displayName: "Style__QuestionTitle",
  componentId: "sc-z6sg4i-2"
})(["margin-bottom:16px;font-size:", "px;line-height:1.15;", " ", ""], ({
  theme: {
    fontSize
  }
}) => fontSize.h5, media.xs`
    font-size: ${({
  theme: {
    fontSize
  }
}) => fontSize.h6}px;
    line-height: 1.22;
    left: 24px;
  `, media.sm`
    & strong {
      font-weight: normal;
    }
  `);
export const QuestionDescription = styled.div.withConfig({
  displayName: "Style__QuestionDescription",
  componentId: "sc-z6sg4i-3"
})(["flex-grow:1;margin-bottom:30px;font-size:", "px;line-height:1.29;.ruble,.price__fraction,span{font-size:", "px;}i{margin:0 5px 3px 0;}"], ({
  theme: {
    fontSize
  }
}) => fontSize.default, ({
  theme: {
    fontSize
  }
}) => fontSize.default);
export const QuestionButtons = styled.div.withConfig({
  displayName: "Style__QuestionButtons",
  componentId: "sc-z6sg4i-4"
})(["display:flex;justify-content:space-between;button{width:100%;}button,.price__fraction,.currency{font-size:inherit;}button + button{margin-left:12px;}", ""], media.xs`
    display: flex;
    flex-direction: column;
    margin-bottom: 28px;

    button + button {
      margin-top: 12px;
      margin-left: 0;
    }
  `);